import Swal from "sweetalert2";

export const showSuccess = (title, text = "") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "success",
    title,
    text,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });
};

export const showError = (title, text = "") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "error",
    title,
    text,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
};

export const showConfirm = async (title, text = "Are you sure?") => {
  const result = await Swal.fire({
    position: "top",
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText: "Yes, continue",
    cancelButtonText: "Cancel",
  });
  return result.isConfirmed;
};
